// Same-day cutoff. From this hour, London wall clock, today is no longer
// bookable: the "Today" option disappears and the date picker starts at
// tomorrow. The hour is the server's (Order::TimeSlots::SAME_DAY_CUTOFF_HOUR,
// handed over by the gwmc layout as window.__SAME_DAY_CUTOFF_HOUR), which also
// refuses a late same-day booking. The literal below is only a fallback.
// 2pm until 2026-10-07, then 12pm (docs/DECISIONS.md).
//
// London, not the browser's clock: a visitor whose laptop is set to another
// zone still sees the cutoff the server enforces.
const runtimeHour =
  typeof window !== 'undefined' && Number.isInteger(window.__SAME_DAY_CUTOFF_HOUR) ? window.__SAME_DAY_CUTOFF_HOUR : null

export const SAME_DAY_CUTOFF_HOUR = runtimeHour !== null ? runtimeHour : 12

// When a same-day washer arrives, as the customer reads it. The server's
// Order::TimeSlots::SAME_DAY_WINDOW_LABEL, handed over by the gwmc layout as
// window.__SAME_DAY_WINDOW_LABEL; the literal is only a fallback. Robin, 8 Oct
// 2026: "operator comes between 2-7pm" (docs/DECISIONS.md).
const runtimeWindow =
  typeof window !== 'undefined' && typeof window.__SAME_DAY_WINDOW_LABEL === 'string' && window.__SAME_DAY_WINDOW_LABEL
    ? window.__SAME_DAY_WINDOW_LABEL
    : null

export const SAME_DAY_WINDOW_LABEL = runtimeWindow || '2pm to 7pm'

// "Today, 2pm to 7pm": a same-day booking's slot, everywhere it is read back.
export const sameDaySlotLabel = (label = SAME_DAY_WINDOW_LABEL) => `Today, ${label}`

// "We'll come between 2pm and 7pm today.": the note under the date once today
// is picked. Same words as the 'Extra for same day' surcharge description.
export const sameDayArrivalNote = (label = SAME_DAY_WINDOW_LABEL) => `We'll come between ${label.replace(' to ', ' and ')} today.`

// "12pm", "2pm", "11am": the hour as the copy says it.
export const cutoffLabel = (hour = SAME_DAY_CUTOFF_HOUR) => {
  if (hour === 0) return '12am'
  if (hour === 12) return '12pm'
  return hour < 12 ? `${hour}am` : `${hour - 12}pm`
}

const londonHourFormat = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: 'numeric', hourCycle: 'h23' })

// The hour (0 to 23) in London at `now`.
export const londonHour = (now = new Date()) => Number(londonHourFormat.format(now))

// Whether today can still be booked at `now`.
export const sameDayOpen = (now = new Date(), cutoffHour = SAME_DAY_CUTOFF_HOUR) => londonHour(now) < cutoffHour
